import { render, staticRenderFns } from "./AntonymsRussianLanguageForm.vue?vue&type=template&id=148fe55a&scoped=true&lang=pug&"
import script from "./AntonymsRussianLanguageForm.vue?vue&type=script&lang=js&"
export * from "./AntonymsRussianLanguageForm.vue?vue&type=script&lang=js&"
import style0 from "./AntonymsRussianLanguageForm.vue?vue&type=style&index=0&id=148fe55a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148fe55a",
  null
  
)

export default component.exports